import { useState, useEffect, useCallback } from "react";
import DraggableDualList from "../DraggableDualList/DraggableDualList";
import PolicyService from "../../services/PoliciesService";

function makeItemId(policy) {
   return `${policy.id}`;
}

function buildTree(allPolicies, selectedPolicies, includeSelected) {
   const policyMap = new Map();

   for (const policy of allPolicies) {
      const belongsToPolicy = selectedPolicies.find(
         (ca) => ca.id === policy.id
      );
      console.log(belongsToPolicy);

      const shouldInclude = includeSelected ? !!belongsToPolicy : !belongsToPolicy;
      if (!shouldInclude) continue;

      const itemId = makeItemId(policy);
      policyMap.set(itemId, {
         id: itemId,
         originalId: itemId,
         type: "item",
         label: policy.name,
         icon: null,
      });
   }

   return Array.from(policyMap.values());
}
function flattenSelectedItems(rightTree) {
   const selected = [];
   for (const node of rightTree) {
      const items = node.type === "group" ? node.children : [node];
      for (const item of items) {
         if (item.type === "item") {
            selected.push({
               id: item.id,
               value: item.id,
               originalId: item.originalId,
               label: item.label,
            });
         }
      }
   }
   return selected;
}

export function PoliciesDDL({ onChangeList, policies }) {
   const [allPolicies, setAllPolicies] = useState([]);
   const [initialLeft, setInitialLeft] = useState([]);
   const [initialRight, setInitialRight] = useState([]);
   const [ready, setReady] = useState(false);

   useEffect(() => {
      (async () => {
         try {
            const response = await PolicyService.listPolicies();
            if (response && response.data) {
               const data = response.data;
               setAllPolicies(data);
            }
         } catch (error) {
            console.error(error);
         }
      })();
   }, []);

   useEffect(() => {
      if (!allPolicies.length) return;

      const left = buildTree(allPolicies, policies, false);
      const right = buildTree(allPolicies, policies, true);

      setInitialLeft(left);
      setInitialRight(right);
      setReady(true);

      if (onChangeList) onChangeList(flattenSelectedItems(left), flattenSelectedItems(right));
   }, [allPolicies]);

   const handleChange = useCallback(
      (leftTree, rightTree) => {
         if (onChangeList) onChangeList(flattenSelectedItems(leftTree), flattenSelectedItems(rightTree));
      },
      [onChangeList]
   );

   if (!ready) return null;

   return (
      <DraggableDualList
         labelLeft="Políticas Disponíveis"
         labelRight="Políticas Selecionadas"
         initialLeft={initialLeft}
         initialRight={initialRight}
         onChange={handleChange}
      />
   );
}